/**
 * 修改 Route query 数据
 * @param {Object} route
 * @param {(Object|null)} [query=null]
 * @return {Object}
 */
export const editRouteQuery = (route, query = null) => {
  const _old = route.query
  let _new = query

  if (query) {
    _new = Object.assign({}, _old, query)
  }

  for (let key in _new) {
    if (!_new[key]) {
      delete _new[key]
    }
  }

  return {
    ...route,
    query: _new
  }
}

/**
 * 通过 VueRoute 返回完整链接
 * @param {Object} route
 * @return {string}
 */
export const getFullPath = (route) => {
  return location.origin + '/#/' + route.fullPath.substr(1)
}



// WEBPACK FOOTER //
// ./src/utils/url.js